import { collectExternalReferences, isNull, nullSafeIsEquivalent, THIS_EXPR } from '@angular/compiler/src/output/output_ast';
import { ToastrService } from "ngx-toastr";
import { FormBuilder, FormGroup } from '@angular/forms';
import { Subject } from 'src/app/Models/subject-breakdown-add-edit';
import { VSubject } from 'src/app/Validators/Validators';
import { Router,ActivatedRoute } from '@angular/router';
import {AppOfflineStore} from '../../../app.offlineService';
import { Injectable,ChangeDetectorRef } from '@angular/core';
import{SubjectManagmentService} from '../../../Services/subject-management/subject-management.service';
import{HttpErrorHandlerService} from '../../../Services/config/http-error-handler.service'

import {
  Component, OnInit, Inject, AfterViewInit, Directive, Input, ViewChild,
  ElementRef, OnDestroy, ChangeDetectionStrategy,
  AfterViewChecked
} from '@angular/core';
import * as $ from 'jquery';
//import { number } from 'ngx-custom-validators/src/app/number/validator';
//import{SubjectManagmentService} from '../../../service/subject-managment.service';
//import { PARAMETERS } from '@angular/core/src/util/decorators';



declare const diveShow:any;
declare const addcollapse:any;

@Component({
  selector: 'app-subjecttree',
  templateUrl: './subjecttree.component.html',
  styleUrls: ['./subjecttree.component.css']
})
@Injectable()
export class SubjecttreeComponent implements OnInit {
  Addform: FormGroup | any;
  InsertSubject: Subject[]=[];
  hideStatus:boolean=true;
  EditedForm:boolean=false;
 
  Breadcrumblist:any;
  subjectById:any;
  ngSelect:string;
  ngSelect1:string;
  @Input() Reload:boolean=false;
  TreeNodeRefresh:any;
  MajorTopic: MajorTopic[]=[];
  //RedirectAssignedresourceId:Number;
  Disbletranslation:boolean=false;
  bracketscheckbox:boolean=false;
  

   ResourceAssignEnabled:boolean=false;
  constructor(private cdr: ChangeDetectorRef,public ser:SubjectManagmentService,private toastr: ToastrService,public ErrorHandler:HttpErrorHandlerService,
    public appser:AppOfflineStore,
    public Mothertongue:AppOfflineStore,
    public Activeroute:ActivatedRoute,
    private fb: FormBuilder,
    public route:Router) { 
      this.lanuage=this.appser.dataStore[0].Language;
      

  }
lanuage:any;

InitializeForm(){
  this.Addform = this.fb.group({
    Subject_Id:[], 
    Subject_Short_Code:[],
    Parent_Subject_Id:[], 
    Subject_Name:["",VSubject], 
    Subject_Level_Type_Code:[], 
    Subject_Status_Type_Code:["",VSubject],  
    Language_Ind:[], 
    Display_Order:[],
    Description_text:[],
    Language_Type_Code:[],
    Translated_Subject_Name:[],
    Translated_Subject_Subject_Status_Type_Code:[], 
    Show_English_Name_Ind:[]
  });
  
}

  

  ngOnInit() {
    this.getsubject(null,null);
    this.getsubjectId(null);
    this.getstatuscode();
    this.InitializeForm();
    this.getCode();
    //this.cdr.detectChanges();
   
    
  
  }
  ngAfterContentChecked(): void {
    this.cdr.detectChanges();
  }




  subjectcode:any;
  getstatuscode()
  {
    this.ser.getstatuscode().subscribe((result) => {
      this.subjectcode=result;
      this.ngSelect=this.subjectcode[0].Subject_Status_Type_Code;
      this.ngSelect1==null;
    }, error => { this.ErrorHandler.handleError(error) }

    );
    
  }
  subject:any;
  getsubject(data:any,d:any){
    let ID:Number=0;
    if(data !=null){ID=Number(data.ID);}
    let list: any = {};
    list["currentNodeID"] = ID;
    list["screenName"] = 'SUBJECT BREAKDOWN';
    list["childRecordStatus"] = 'ALL';
    list["CalledFrom"] = 'SUBJECT';
    this.ser.getSubjectTree(list).subscribe((result) => {
      this.subject=result;
    }, error => { this.ErrorHandler.handleError(error) }
    );
  }

  getcodes:any;
  getCode()
  {
    this.ser.GetCode({'Tablename':"SUBJECT_LEVEL_TYPE"}).subscribe((i:any)=>{
      this.getcodes=i;     
    }, (error:any) => { console.log(error) }
    );
  }



 
  statusvalidate:string;
  DefaultStatus:any;
  getsubjectId(data:any)
  {
     let ID:Number=0;
     try{
     if(data>0||data==null)
     {
      ID=Number(data);
     }
     else if(Number(data.ID)>0){
      ID=Number(data.ID);
     }
    }catch{
     }
     this.ser.getsubjectById({'CurrentNodeSubjectID':Number(ID)}).subscribe((i:any)=>{
      this.subjectById=i;
      this.statusvalidate=this.subjectById.Subject_Id;
      
      if(this.subjectById.Language_Ind =='Y')
      {
        this.Disbletranslation=true;
      }
      else{
        this.Disbletranslation=false;
      }
      if(this.subjectById.Show_English_Name_Ind=='Y')
      {
        this.bracketscheckbox=true;
      }
      else{
        this.bracketscheckbox=false;
      }
      if(this.Editsubjectflag)
      {
         this.Addform.setValue(this.subjectById);
        this.EditedForm=true;
      }
      
     
      try{
      if(data.Reload===true)
      {
      this.Reload=true;
      }}catch{}
      if(this.Reload){
         this.Addform.setValue(this.subjectById);
        this.EditedForm=true;
        }
        if(!this.EditedForm){
          this.ngSelect1==null;
          this.subjectById.Translated_Subject_Subject_Status_Type_Code=null; 
          this.bracketscheckbox=false;
         this.subjectById.Show_English_Name_Ind='N'; 
         this.subjectById.Translated_Subject_Subject_Status_Type_Code=null; 
          this.Addform.controls['Translated_Subject_Subject_Status_Type_Code'].setValue(null);
        }
        
      }, error => { this.ErrorHandler.handleError(error) }
      );
   
  }

  selectedsubject:any;
  SelectSubject(data:any){
     this.selectedsubject=data.target.value;
     this.getsubjectData(data.target.value,'MT',null)
  }

  parentid:any;
  breadcrumbID:any = [];
  Dynamic:any;
  Refresh:any;
  Descriptionvalue:any;

  getsubjectData(data:any,name:string,M:any,C?:any,SC1?:any,SC2?:any,SC3?:any,SC4?:any,SC5?:any){
    
//let cc=this.MajorTopic[M].Data[C];
    let majortopicsarr:any=[];
    if(this.MajorTopic!=null){
    majortopicsarr=this.MajorTopic;
    }
    this.getsubjectId(data);
    this.getBreadcrumbDetails(data);
    let ID:Number=0; 
    if(data !=null){ID=Number(data);}
    let list: any = {};
    list["currentNodeID"] = ID;
    list["screenName"] = 'SUBJECT BREAKDOWN';
    list["childRecordStatus"] = 'ALL';
    list["CalledFrom"] = 'SUBJECT';
    
    this.ser.getSubjectTree(list).subscribe((i:any)=>{
     
      if(name == 'MT'){
        this.MajorTopic=i;

        this.subject.forEach((i: { ID: any; }) => {
          if(Number(i.ID)=== Number(ID)){
          }   
        });
      }
      else if(name == 'C'){
        if(this.MajorTopic[M].Data !== null)
        this.MajorTopic[M].Data=null;
        else{
          this.MajorTopic[M].Data=i;
        }
      }
      else if(name == 'SC1'){
        if(this.MajorTopic[M].Data[C].Data !== null)
        this.MajorTopic[M].Data[C].Data=null;
        else{
        this.MajorTopic[M].Data[C].Data=i;
        }
      }
      else if(name == 'SC2'){
        if(this.MajorTopic[M].Data[C].Data[SC1].Data !== null)
        this.MajorTopic[M].Data[C].Data[SC1].Data=null;
        else{
        this.MajorTopic[M].Data[C].Data[SC1].Data=i;
        }
      }
      else if(name == 'SC3'){
        if(this.MajorTopic[M].Data[C].Data[SC1].Data[SC2].Data !== null)
        this.MajorTopic[M].Data[C].Data[SC1].Data[SC2].Data=null;
        else{
        this.MajorTopic[M].Data[C].Data[SC1].Data[SC2].Data=i;
        }
      }
      else if(name == 'SC4'){
        if(this.MajorTopic[M].Data[C].Data[SC1].Data[SC2].Data[SC3].Data !== null)
        this.MajorTopic[M].Data[C].Data[SC1].Data[SC2].Data[SC3].Data=null;
        else{
        this.MajorTopic[M].Data[C].Data[SC1].Data[SC2].Data[SC3].Data=i;
        }
      }
      else if(name == 'SC5'){
        if(this.MajorTopic[M].Data[C].Data[SC1].Data[SC2].Data[SC3].Data[SC4].Data !== null)
        this.MajorTopic[M].Data[C].Data[SC1].Data[SC2].Data[SC3].Data[SC4].Data=null;
        else{
        this.MajorTopic[M].Data[C].Data[SC1].Data[SC2].Data[SC3].Data[SC4].Data=i;
        }
      }
      else if(name == 'SC6'){
        if(this.MajorTopic[M].Data[C].Data[SC1].Data[SC2].Data[SC3].Data[SC4].Data[SC5].Data !== null)
        this.MajorTopic[M].Data[C].Data[SC1].Data[SC2].Data[SC3].Data[SC4].Data[SC5].Data=null;
        else{
        this.MajorTopic[M].Data[C].Data[SC1].Data[SC2].Data[SC3].Data[SC4].Data[SC5].Data=i;
        }
     
      }
      console.log(this.MajorTopic, 'MAJORTOPICSS....................');
      
      }, error => { this.ErrorHandler.handleError(error) }
      );
    }



 
  NewConceptModel:any;
  addNewConcept(data:any,name:string,M:any,C?:any,SC1?:any,SC2?:any,SC3?:any,SC4?:any,SC5?:any,SC6?:any){
    for (let item of this.getcodes) {
      if(item.Code=="SCL1")
      item.Code='SC1';
      else if(item.Code=="SCL2")
      item.Code='SC2'
      else if(item.Code=="SCL3")
      item.Code='SC3'
      else if(item.Code=="SCL4")
      item.Code='SC4'
      else if(item.Code=="SCL5")
      item.Code='SC5'
      else if(item.Code=="SCL6")
      item.Code='SC6'
      else
      item.Code;
      if (item.Code==name) {
        this.Descriptionvalue=item.Description;
      }
    }
    this.getsubjectId(null);
    this.InitializeForm();
    this.getCode(); 
    this.Editsubjectflag=false;
    this.ngSelect==null;
    this.Reload=false;
    this.Addnewsubject=true;
    this.EditedForm=false;
    this.hideStatus=false;
    this.edit();
   
    
    

  
    if(name=='MT')
    {
      if(data.length==0){
        
        this.getBreadcrumbDetails(this.subjectById.Subject_Id);
        this.getsubjectId(this.subjectById.Subject_Id);
        this.Refresh = {
         dataID:this.subjectById.Subject_Id,name:name,
         M:M,C:C,SC1:SC1,SC2:SC2,SC3:SC3,SC4:SC4,SC5:SC5
        }
        for (let item of this.getcodes) {
          if (item.Code==name) {
            this.Descriptionvalue=item.Description;
          }
        }
      }
      else{
        this.getBreadcrumbDetails(data[0].Parent_Id);
       this.getsubjectId(data[0].Parent_Id);
        this.Refresh = {
          dataID:data[0].Parent_Id,name:name,
          M:M,C:C,SC1:SC1,SC2:SC2,SC3:SC3,SC4:SC4,SC5:SC5
         }
         for (let item of this.getcodes) {
          if (item.Code==name) {
            this.Descriptionvalue=item.Description;
          }
        }
      }
        
    }
    else{
    this.getBreadcrumbDetails(data.ID);
    this.getsubjectId(data.ID);
    this.Refresh = {
      dataID:data.ID,name:name,
      M:M,C:C,SC1:SC1,SC2:SC2,SC3:SC3,SC4:SC4,SC5:SC5,SC6:SC6
     }
     
    
    } 

    
  
   

  }

  enableedit:boolean=true;
  edit(){
    this.enableedit=!this.enableedit;
  }

  Addnewsubject:boolean=false;
  AddNewSubject(){
    this.Addnewsubject=!this.Addnewsubject;
    this.hideStatus=false;
  }

  Editsubjectflag:Boolean=false;
  EditSubject(data:any,name:string,M:any,C?:any,SC1?:any,SC2?:any,SC3?:any,SC4?:any,SC5?:any,SC6?:any){
    for (let item of this.getcodes) {
      if(item.Code=="SCL1")
      item.Code='SC1';
      else if(item.Code=="SCL2")
      item.Code='SC2'
      else if(item.Code=="SCL3")
      item.Code='SC3'
      else if(item.Code=="SCL4")
      item.Code='SC4'
      else if(item.Code=="SCL5")
      item.Code='SC5'
      else if(item.Code=="SCL6")
      item.Code='SC6'
      else
      item.Code;
      if (item.Code==name) {
        this.Descriptionvalue=item.Description;
      }
    }
  this.Editsubjectflag=true;
  this.Addnewsubject=false;
  this.hideStatus=false;
  this.edit();
  this.getsubjectId(data.ID);
  this.getBreadcrumbDetails(data.ID);
  this.Refresh = {
    dataID:data.Parent_Id,name:name,
    M:M,C:C,SC1:SC1,SC2:SC2,SC3:SC3,SC4:SC4,SC5:SC5,SC6:SC6
   }

  if(this.Reload){
     this.Addform.setValue(this.subjectById);
    this.EditedForm=true;
    }
   
  }

  reset(data:any){
    this.hideStatus=true;
    this.InitializeForm();
    
    this.edit();
   
  }
  getBreadcrumbDetails(data:any){
    this.ser.getBreadcrumbDetails({'ID':data}).subscribe((i:any)=>{
      if(!this.EditedForm){
        this.Breadcrumblist=i;
      }
      else{
       
        this.Breadcrumblist=[];
        for(let j=0;j<i.length-1;j++){
          this.Breadcrumblist.push(i[j]);
        }
      }
      
    
  }, error => { this.ErrorHandler.handleError(error) }
  );

  }

  getsubjectDataRefresh(data:any){
    this.Refresh=data;
    let ID:Number=0; 
    if(this.Refresh.dataID !=null){ID=Number(this.Refresh.dataID);}
    let list: any = {};
    list["currentNodeID"] = ID;
    list["screenName"] = 'SUBJECT BREAKDOWN';
    list["childRecordStatus"] = 'ALL';
    list["CalledFrom"] = 'SUBJECT';
    this.ser.getSubjectTree(list).subscribe((i:any)=>{    
      if(this.Refresh.name == 'MT'){
        this.MajorTopic=i;
        this.subject.forEach((i: { ID: any; }) => {
          if(Number(i.ID)=== Number(ID)){
          }   
        });
      }
      else if(this.Refresh.name == 'C'){
       
        this.MajorTopic[this.Refresh.M].Data=i;
        try{
          if(Number(this.MajorTopic[this.Refresh.M].Data.length) > 0){
            this.MajorTopic[this.Refresh.M].ChildNodeExistInd="Y";
          }else{
            this.MajorTopic[this.Refresh.M].ChildNodeExistInd="N";
          }
        }
        catch{

        }
        
        
      }
      else if(this.Refresh.name == 'SC1'){
        
        this.MajorTopic[this.Refresh.M].Data[this.Refresh.C].Data=i;
        try{
          if(Number(this.MajorTopic[this.Refresh.M].Data[this.Refresh.C].Data.length) > 0){
            this.MajorTopic[this.Refresh.M].Data[this.Refresh.C].ChildNodeExistInd="Y";
          }else{
            this.MajorTopic[this.Refresh.M].Data[this.Refresh.C].ChildNodeExistInd="N";
          }
        }
        catch{

        }
        
      }
      else if(this.Refresh.name == 'SC2'){
        
        this.MajorTopic[this.Refresh.M].Data[this.Refresh.C].Data[this.Refresh.SC1].Data=i;
        try{
          if(Number(this.MajorTopic[this.Refresh.M].Data[this.Refresh.C].Data[this.Refresh.SC1].Data.length) > 0){
            this.MajorTopic[this.Refresh.M].Data[this.Refresh.C].Data[this.Refresh.SC1].ChildNodeExistInd="Y";
          }else{
            this.MajorTopic[this.Refresh.M].Data[this.Refresh.C].Data[this.Refresh.SC1].ChildNodeExistInd="N";
          }
        }
        catch{

        }
        
      }
      else if(this.Refresh.name == 'SC3'){
       
        this.MajorTopic[this.Refresh.M].Data[this.Refresh.C].Data[this.Refresh.SC1].Data[this.Refresh.SC2].Data=i;
        try{
          if(Number(this.MajorTopic[this.Refresh.M].Data[this.Refresh.C].Data[this.Refresh.SC1].Data[this.Refresh.SC2].Data.length) > 0){
            this.MajorTopic[this.Refresh.M].Data[this.Refresh.C].Data[this.Refresh.SC1].Data[this.Refresh.SC2].ChildNodeExistInd="Y";
          }else{
            this.MajorTopic[this.Refresh.M].Data[this.Refresh.C].Data[this.Refresh.SC1].Data[this.Refresh.SC2].ChildNodeExistInd="N";
          }
        }
        catch{

        }
        
      }
      else if(this.Refresh.name == 'SC4'){
       
        this.MajorTopic[this.Refresh.M].Data[this.Refresh.C].Data[this.Refresh.SC1].Data[this.Refresh.SC2].Data[this.Refresh.SC3].Data=i;
        try{
          if(Number(this.MajorTopic[this.Refresh.M].Data[this.Refresh.C].Data[this.Refresh.SC1].Data[this.Refresh.SC2].Data[this.Refresh.SC3].Data.length) > 0){
            this.MajorTopic[this.Refresh.M].Data[this.Refresh.C].Data[this.Refresh.SC1].Data[this.Refresh.SC2].Data[this.Refresh.SC3].ChildNodeExistInd="Y";
          }else{
            this.MajorTopic[this.Refresh.M].Data[this.Refresh.C].Data[this.Refresh.SC1].Data[this.Refresh.SC2].Data[this.Refresh.SC3].ChildNodeExistInd="N";
          }
        }
        catch{

        }
        
      }
      else if(this.Refresh.name == 'SC5'){
        
        this.MajorTopic[this.Refresh.M].Data[this.Refresh.C].Data[this.Refresh.SC1].Data[this.Refresh.SC2].Data[this.Refresh.SC3].Data[this.Refresh.SC4].Data=i;

        try{
          if(Number(this.MajorTopic[this.Refresh.M].Data[this.Refresh.C].Data[this.Refresh.SC1].Data[this.Refresh.SC2].Data[this.Refresh.SC3].Data[this.Refresh.SC4].Data.length) > 0){
            this.MajorTopic[this.Refresh.M].Data[this.Refresh.C].Data[this.Refresh.SC1].Data[this.Refresh.SC2].Data[this.Refresh.SC3].Data[this.Refresh.SC4].ChildNodeExistInd="Y";
          }else{
            this.MajorTopic[this.Refresh.M].Data[this.Refresh.C].Data[this.Refresh.SC1].Data[this.Refresh.SC2].Data[this.Refresh.SC3].Data[this.Refresh.SC4].ChildNodeExistInd="N";
          }
        }
        catch{

        }
        
      }
      else if(this.Refresh.name == 'SC6'){
        
        this.MajorTopic[this.Refresh.M].Data[this.Refresh.C].Data[this.Refresh.SC1].Data[this.Refresh.SC2].Data[this.Refresh.SC3].Data[this.Refresh.SC4].Data[this.Refresh.SC5].Data=i;
        try{
          if(Number(this.MajorTopic[this.Refresh.M].Data[this.Refresh.C].Data[this.Refresh.SC1].Data[this.Refresh.SC2].Data[this.Refresh.SC3].Data[this.Refresh.SC4].Data[this.Refresh.SC5].Data.length) > 0){
            this.MajorTopic[this.Refresh.M].Data[this.Refresh.C].Data[this.Refresh.SC1].Data[this.Refresh.SC2].Data[this.Refresh.SC3].Data[this.Refresh.SC4].Data[this.Refresh.SC5].ChildNodeExistInd="Y";
          }else{
            this.MajorTopic[this.Refresh.M].Data[this.Refresh.C].Data[this.Refresh.SC1].Data[this.Refresh.SC2].Data[this.Refresh.SC3].Data[this.Refresh.SC4].Data[this.Refresh.SC5].ChildNodeExistInd="N";
          }
        }
        catch{

        }
        
     
      }

  }, error => { this.ErrorHandler.handleError(error) }
  );
   
  }





  

    checkToEnableAddEdit(){
      if(this.Addnewsubject === true){
          this.enableedit=true;
        }
        else if(this.Editsubjectflag === true){
          this.enableedit=true;
        }
        else{
          this.enableedit=false;
        }
    }
  
    mouseoverevent(ID:Number,P1:string,P2?:string):boolean{
  
      if(this.enableedit == true && Number(this.selectedvalue) == ID &&( P1 === this.selectedkey || this.selectedkey == P2) && P2!= null){return true;}
  
      else if(this.enableedit == true && Number(this.selectedvalue) == ID && P1 === this.selectedkey){return true;}
  
      else{return false;}
  
    }
  
    selectedvalue:Number;
      selectedkey:string="";
      OnSelect(Value?:Number,d?:any){
      
        if(Value == null){
          return;
        }
        else if(Number(Value)>0){
        this.selectedvalue=Number(Value);
      this.selectedkey=d;}  
        else{
          this.selectedvalue=0;
          this.selectedkey=d;}
      }

  

      
  } 

interface MajorTopic{
  ChildNodeExistInd:string;
  Data: any;
  Display_Order: Number;
  ID: Number;
  Name: string;
  Parent_Id:Number;
  Status_Code: string;
  Subject_Level_Type_Code: string;
}